<template lang="pug">
  SspLayout(area="core")
    .row
      .col-sm-12
        .panel.panel-default
          .panel-heading
            .panel-title User Details
            .text-center.loading(v-if="loading")
              i.fa.fa-spinner.fa-pulse.fa-spin
          .panel-body(v-if="user")
            .container-fluid
              .row
                label.col-sm-2.control-label Name
                .col-sm-4 {{user.username}}

                label.col-sm-2.control-label Email
                .col-sm-4 {{user.email}}

              .row
                label.col-sm-2.control-label Organization
                .col-sm-4(v-if="organization") {{organization.name}}

                label.col-sm-2.control-label Created
                .col-sm-4 {{user.created | date}}

              hr
              .row
                label.col-sm-2.control-label Groups
                PillsList.col-sm-10(:items="groups" :clickable="true"  @itemClick="goToGroup")

              hr
              .row
                label.col-sm-2.control-label Roles
                PillsList.col-sm-10(:items="roles")
          .panel-footer
            .text-right.pt10
              button.btn.btn-default(type="button" @click="toggleEdit") {{!editMode ? 'Change Password' : 'Cancel'}}

        .password-edit(v-if="editMode")
          SspSaveForm(@onSubmit="changePassword" :saveDisabled="!isValid" :saving="saving" :hasCancel="false")
            .form-group
              label.col-sm-4.control-label New Password
              .col-sm-8
                input.form-control(type="password" placeholder="New Password" v-model="password")
            .form-group
              label.col-sm-4.control-label Retype Password
              .col-sm-8
                input.form-control(type="password" placeholder="Retype Password" v-model="rePassword")
</template>

<script>
import miniToastr from 'mini-toastr'
import Security from '@/service/apis/Security'
import PillsList from '@/components/common/PillsList'
import { dateFilter } from '@/filters/filters'

export default {
  data: () => ({
    saving: false,
    user: null,
    loading: false,
    organization: null,
    editMode: false,
    password: null,
    rePassword: null
  }),
  created() {
    this.loading = true
    Security.getCurrentUser()
      .then((resp) => {
        this.user = resp.data
      })
      .then(() => {
        Security.getOrganization()
          .then((resp) => {
            this.organization = resp.data.organization
            this.loading = false
          })
      })
  },
  methods: {
    changePassword() {
      this.saving = true
      Security.changeCurrentUserPassword({ password: this.password })
        .then(() => {
          miniToastr.success('Password successfully changed')
          this.toggleEdit()
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.saving = false
        })
    },
    goToGroup(data) {
      this.$router.push({ name: 'group', params: { id: data.id } })
    },
    toggleEdit() {
      this.editMode = !this.editMode
    },
  },
  computed: {
    passwordMatching() {
      return this.rePassword === this.password
    },
    isValid() {
      return this.password && this.passwordMatching
    },
    groups() {
      return this.user.groupMemberships.group.map((g) => ({ name: g.name, id: g.id }))
    },
    roles() {
      return this.user.roles.role.map((r) => ({ name: r.replace('ROLE_', '').replace(/_/g, ' ') }))
    }
  },
  components: {
    PillsList
  },
  filters: {
    date: dateFilter
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/security/UserPreference.vue